import { apiCMSWithToken } from './axios'

export const url = {
  banner: `/banner`
}

export async function getSlideImage(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.banner}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function slideImageAdd(body) {
  const response = await apiCMSWithToken.post(`${url.banner}`, body)
  return response
}
export async function slideImageUpdate(body, id) {
  const response = await apiCMSWithToken.put(`${url.banner}/${id}`, body)
  return response
}

export async function deleteSlideImage(body, id) {
  try {
    const response = await apiCMSWithToken.delete(`${url.banner}/${id}`, {
      data: body
    })
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export default {
  getSlideImage,
  slideImageAdd,
  slideImageUpdate,
  deleteSlideImage
}
